import { IPlayerProfile, RankTier } from '../core/types';

export class SaveSystem {
    private static instance: SaveSystem;
    private readonly STORAGE_KEY = 'zentryx_domino_profile';

    private constructor() {}

    static getInstance(): SaveSystem {
        if (!SaveSystem.instance) {
            SaveSystem.instance = new SaveSystem();
        }
        return SaveSystem.instance;
    }

    save(profile: IPlayerProfile) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(profile));
    }

    load(): IPlayerProfile {
        const data = localStorage.getItem(this.STORAGE_KEY);
        if (data) {
            try {
                return JSON.parse(data) as IPlayerProfile;
            } catch (e) {
                console.error('Failed to parse save data', e);
            }
        }
        return this.getDefaultProfile();
    }

    clear() {
        localStorage.removeItem(this.STORAGE_KEY);
    }

    getDefaultProfile(): IPlayerProfile {
        return {
            name: 'Jugador',
            avatarId: 'default',
            coins: 1000,
            gems: 50,
            xp: 0,
            level: 1,
            rank: RankTier.Bronze,
            wins: 0,
            losses: 0,
            draws: 0,
            gamesPlayed: 0,
            winStreak: 0,
            bestWinStreak: 0,
            ownedSkins: ['default'],
            equippedTileSkin: 'default',
            equippedBoardSkin: 'default',
            equippedAvatar: 'default',
            dailyMissionsCompleted: 0,
            lastDailyReset: new Date().toISOString()
        };
    }
}
